const LAYOUT_TYPES = {
  SET_APPBAR_TITLE: '[layout] setAppBarTitle',
  SET_IS_LOADING: '[layout] setIsLoading',
  SET_DRAWER_MENU_OPEN: '[layout] setDrawerMenuOpen',
  SET_CHAT_DRAWER_OPEN: '[layout] setChatDrawerOpen',
  TOGGLE_CHAT_DRAWER: '[layout] toggleChatDrawer',
  OPEN_MAIN_CHAT_FOR_DEVICE: '[layout] openMainChatForDevice',
  CLEAR_MAIN_CHAT_DEVICE: '[layout] clearMainChatDevice',
  OPEN_MAIN_CHAT_FOR_CHAT_GROUP: '[layout] openMainChatForChatGroup',
  CLEAR_MAIN_CHAT_CHAT_GROUP: '[layout] clearMainChatChatGroup',
  SET_FRAMELESS_MODE_TURNED_ON: '[layout] setFramelessModeTurnedOn'
}

export default LAYOUT_TYPES
